import { Component, OnInit } from '@angular/core';
// import { NzTabPosition } from 'ng-zorro-antd/tabs';
// import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list'

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { DSHeaderJSON } from 'app/shared/cstm-header/cstm-header.component';




@Component({
  selector: 'app-help-home',
  templateUrl: './help-home.component.html',
  styleUrls: ['./help-home.component.scss']
})
export class HelpHomeComponent implements OnInit {
  // position: NzTabPosition = 'left';
  relsntes;
  helpdoc;
  helpvedio;
  helpfaq;
  support;
  ParamsDta;
  params: any;
  selectedTabIndex: number;

  dsHeader: DSHeaderJSON = {
    shw_hdr: true,
    title: 'Help Documentation',
    sub_title: 'All the product documentation in one location.',
    shw_fltr: false,
    srch_in: false,
    srch_ph_tx: 'Search for help',
    fltr_jsn: [

    ]
  }


  constructor(private route: ActivatedRoute) {
    this.route.queryParams

      .subscribe(params => {
        console.log(params); // { order: "popular" }
        if (params.id == 37) {
          this.params = params
          console.log(params.id)
          this.selectChnageTab({ index: 4, tab: '' });
        }


      }
      );
  }

  ngOnInit() {
    if (this.params && this.params.id) {
      console.log("pppppppp")
      // this.selectChnageTab({index: 4,tab: ''});
      this.selectedTabIndex = 4
      this.support = true;
      this.relsntes = false;
    }
    else {
      console.log("jjjjjjjjjjjjjjjj")
      this.selectChnageTab({ index: 0, tab: '' });
    }


  }
  selectChnageTab(e) {
    console.log(e)
    // if(e.index==0){
    //   this.relsntes=true;
    //   this.support=false;
    // }
    if (e.index == 0) {
      this.helpdoc = true;
      this.support = false;
    }
    if (e.index == 1) {
      this.helpvedio = true;
      this.support = false;
    }
    if (e.index == 2) {
      this.helpfaq = true;
      this.support = false;
    }
    if (e.index == 3) {
      this.support = true;
    }
  }



  onGetFilterActionEvntEmtr(event) {
    if (event) {
      // this.searchText = event['inpt_srch_txt'];
    }
  }

}
